import { HOTELS_HOST, LUXE_HOST, HOLIDAY_PACKAGES_HOST } from './env';

// QH support numbers
export const DOMESTIC_PHONE_NUMBER = '1300 738 206';
export const INTERNATIONAL_PHONE_NUMBER = '+61 2 8059 0182';
export const PARTNER_SERVICES_PHONE_NUMBER = '1300 558 610';
export const LIVE_CHAT_OPERATING_TIMES = '8:30am - 5:30pm (AEDT/AEST)';
export const PHONE_SUPPORT_OPERATING_TIMES = '8:30am - 5:30pm (AEDT/AEST)';

export const TRIP_ADVISOR_IMG_BRANDING_URL =
  'https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-15969-0.svg';

// Internal links
export const CONTACT_US = '/contact-us';
export const CONTACT_US_LIVE_CHAT = '/contact-us#live-chat';
export const CONTACT_US_FORM = '/contact-us/email';
export const FAQS = '/faqs';
export const DESTINATIONS_AUSTRALIA = '/australia';

// Internal URLs (used for print views)
export const QH_CONTACT_US_URL = `${HOTELS_HOST}/hotels${CONTACT_US}`;
export const QH_FAQ_URL = `${HOTELS_HOST}/hotels${FAQS}`;

// External urls
export const QCOM_LANDING_PAGE_URL = 'https://www.qantas.com/au/en/book-a-trip/hotels-and-airbnb.html';
export const QCOM_PRICE_PROMISE_URL = 'https://www.qantas.com/au/en/travel/airlines/price-promise/global/en';
export const QCOM_PRIVACY_AND_SECURITY_URL = 'https://www.qantas.com/au/en/support/privacy-and-security.html';
export const QCOM_TERMS_AND_CONDITIONS_URL = 'https://www.qantas.com/au/en/book-a-trip/hotels-and-airbnb/terms-and-conditions.html';
export const QCOM_TERMS_OF_USE_URL = 'https://www.qantas.com/au/en/support/terms-of-use.html';

export const QFF_MY_ACCOUNT_URL = 'https://www.qantas.com/au/en/frequent-flyer/my-account.html';
export const QFF_MY_PROFILE_URL = 'https://www.qantas.com/au/en/frequent-flyer/my-account/profile.html';
export const QFF_MY_POINTS_ACTIVITY_URL = 'https://www.qantas.com/au/en/frequent-flyer/my-account/points-activity.html';

export const QFF_SIGNUP_URL = 'https://www.qantas.com/fflyer/dyns/joinff';

export const QH_DEALS_URL = `${HOTELS_HOST}/hotels/deals`;
export const QH_LUXE_URL = LUXE_HOST;
export const QH_PACKAGES_URL = HOLIDAY_PACKAGES_HOST;
export const QH_SELF_SERVICE_URL = `${HOTELS_HOST}/hotels/manage/bookings`;
export const QH_TERMS_AND_CONDITIONS_URL = 'https://www.qantas.com/hotels/terms-and-conditions';

export const QH_DREAM_PLANNER_URL = 'https://www.qantas.com/au/en/frequent-flyer/my-account/dream-planner.html';

export const QCOM_TRAVELPASS_TERMS_URL = 'https://www.qantas.com/au/en/book-a-trip/flights/payment-options/travelpass.html#conditions';
export const QCOM_TRAVELPASS_BALANCE_URL = 'https://www.qantas.com/quisportal/';
